export const UN_AUTHORIZED =
  'Your session has expired, please log in to access this page.';

export const PAYPAL_ERROR_MESSAGES = {
  PAYPAL_TOKENIZATION_REQUEST_ACTIVE: 'PayPal window is already active',
};
